import { FormLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { PRIORITIES } from '@/utils/constants';
import { minimalLabelTheme } from '@/app/theme';

export const PrioritySelect = ({ priority, disabled, setPriority, minimal, ...props }) => {


	return <>
		<FormLabel sx={minimal ? minimalLabelTheme : undefined}>{'Priority'}</FormLabel>
		<Select
			name="priority"
			value={priority}
			disabled={disabled}
			onChange={(e) => setPriority(e.target.value)}
			fullWidth={true}
			{...props}
		>
			{PRIORITIES.map((value) => {
				return (
					<MenuItem
						value={value}
						key={`priority-selection-${value}`}
					>
						{value}
					</MenuItem>
				);
			})}
		</Select>
	</>;
};